// Cognito requires exact match; normalize to no trailing slash so it matches Terraform callback_urls
const normalizeRedirect = (url: string | undefined): string =>
  (url || (typeof window !== 'undefined' ? `${window.location.origin}/` : '')).replace(/\/+$/, '') || '';

export const AuthConfig = {
  aws_project_region: process.env.REACT_APP_AWS_REGION,
  aws_cognito_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_USER_POOLS_ID,
  aws_user_pools_web_client_id: process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID,
  oauth: {
    domain: process.env.REACT_APP_AWS_OAUTH_DOMAIN,
    scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: normalizeRedirect(process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNIN),
    redirectSignOut: normalizeRedirect(process.env.REACT_APP_AWS_OAUTH_REDIRECT_SIGNOUT),
    responseType: 'code',
  },
  federationTarget: 'COGNITO_USER_POOLS',
};
